import { render, staticRenderFns } from "./evaluations-reports.vue?vue&type=template&id=358d158f&"
import script from "./evaluations-reports.vue?vue&type=script&lang=js&"
export * from "./evaluations-reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports